module.exports = __webpack_public_path__ + "img/radio-default.53ba5d30.svg";